module.exports = __webpack_public_path__ + "static/Emanuela_Rota-8039427c05e89f4bf8abb8dd083b7117.jpg";